module.exports = __webpack_public_path__ + "img/彭博.21c55cc8.jpg";